import React from 'react';
import Typography from '@mui/material/Typography';

export default function LiveMonitoring() {
  return (
    <div>
      <Typography variant="h4" gutterBottom>Live Monitoring</Typography>
      <Typography>This is the Live Monitoring page.</Typography>
    </div>
  );
}
